import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { ToastComponent } from './toast.component';
import { ToastConfig } from './toast.types';

const TOAST_OFFSET = 24;
const NAV_SELECTOR = 'twaice-fe-dashboard-sidenav';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private overlayRef: OverlayRef | null = null;

  constructor(private overlay: Overlay) {}

  show(config: ToastConfig): void {
    this.close();
    const overlayRef = this.overlay.create({
      positionStrategy: this.overlay
        .position()
        .global()
        .bottom(`${TOAST_OFFSET}px`)
        .left(`${this.getNavRight() + TOAST_OFFSET}px`),
    });
    const toastRef = overlayRef.attach(new ComponentPortal(ToastComponent));
    toastRef.setInput('config', config);
    toastRef.instance.dismissed.subscribe(() => {
      overlayRef.dispose();
      if (this.overlayRef === overlayRef) {
        this.overlayRef = null;
      }
    });
    this.overlayRef = overlayRef;
  }

  close(): void {
    this.overlayRef?.dispose();
    this.overlayRef = null;
  }

  private getNavRight(): number {
    return document.querySelector(NAV_SELECTOR)?.getBoundingClientRect().right ?? 0;
  }
}
